import { ChallengeDelivery, ChallengeReason, ChallengeType } from '../../enums/auth';
import { Expose, Transform, Type } from 'class-transformer';
import { IsOptional, IsString } from 'class-validator';

export class ChallengeDetailsDto {
    @Expose()
    @Transform(({ value }) => {
        const suffix = value.substring(value.length - 3);
        const maskedPart = '*'.repeat(value.length - 3);
        return `${maskedPart}${suffix}`;
    })
    @IsString()
    phoneNumber: string;
}

export class ChallengeDto {
    @Expose()
    type: ChallengeType;

    @Expose()
    reason: ChallengeReason;

    @Expose()
    delivery: ChallengeDelivery | null;

    @Expose()
    @IsOptional()
    @Type(() => ChallengeDetailsDto)
    details?: ChallengeDetailsDto;
}
